import * as React from 'react';
import { pieArcLabelClasses, PieChart } from '@mui/x-charts/PieChart';
import { Box } from '@mui/material';

const convertApiCallDataForChart = (apiCallStats) => {
    if (!apiCallStats || typeof apiCallStats !== 'object') return [];

    return Object.entries(apiCallStats).map(([code, value], index) => ({
        id: index,
        value: value?.count || 0,
        label: `Status ${code}`,
    }));
};


export default function TotalApiCallsPie({ data }) {
    const chartData = convertApiCallDataForChart(data);

    const size = {
        width: 400,
        height: 450,
    };

    if (!chartData.length) {
        return <Box sx={{ textAlign: 'center', mt: 4 }}>No API call data available</Box>;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 3,
                mb: 2,
            }}
        >
            <PieChart
                series={[
                    {
                        data: chartData,
                        arcLabel: (item) => `${item.label}: ${item.value}`,
                        arcLabelMinAngle: 10,
                        arcLabelRadius: '60%',
                    },
                ]}
                slotProps={{
                    legend: {
                        direction: 'row',
                        position: { vertical: 'bottom', horizontal: 'center' },
                        sx: {
                            mt: 2,
                        },
                    },
                }}
                sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                        fontWeight: 'bold',
                    },
                }}
                {...size}
            />
        </Box>
    );
}
